/**
 * Assignment Courses Tab Component
 * Shows list of courses in the assignment
 */

import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
} from '@mui/material'
import { CourseIcon } from 'src/v3/core/icons'
import type { SingleUserAssignmentDetails } from 'src/v3/manage/manage.slice'

interface CoursesTabProps {
  assignment: SingleUserAssignmentDetails
}

export default function CoursesTab({ assignment }: CoursesTabProps) {
  return (
    <Box>
      <Typography variant="h6" className="mb-4">
        Assigned Courses ({assignment.courses.length})
      </Typography>

      {assignment.courses.length === 0 ? (
        <Typography color="text.secondary" className="italic py-8 text-center">
          No courses assigned to this assignment.
        </Typography>
      ) : (
        <List
          dense
          sx={{ maxHeight: 400, overflow: 'auto' }}
          role="list"
          aria-label="Assignment courses"
        >
          {assignment.courses.map((course, index) => (
            <ListItem
              key={course.id || index}
              sx={{
                px: 0,
                py: 1,
                borderBottom:
                  index < assignment.courses.length - 1 ? '1px solid' : 'none',
                borderColor: 'divider',
              }}
            >
              <Box className="flex items-center gap-4 w-full">
                <CourseIcon sx={{ color: 'primary.main' }} />
                <ListItemText
                  primary={
                    <Typography variant="body1" className="font-medium">
                      {course.displayName ||
                        course.name ||
                        `Course ${index + 1}`}
                    </Typography>
                  }
                  secondary={
                    <Box className="flex gap-2 mt-1">
                      {course.length > 0 && (
                        <Chip
                          label={`${course.length} CE Hours`}
                          size="small"
                          variant="outlined"
                          color="success"
                        />
                      )}
                      {course.courseCompletionStatus && (
                        <Chip
                          label={course.courseCompletionStatus}
                          size="small"
                          variant="outlined"
                          color="success"
                        />
                      )}
                    </Box>
                  }
                />
              </Box>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  )
}
